// @ts-check
import axios from 'axios';

/** @typedef {import('axios').AxiosRequestConfig} AxiosRequestConfig */
/** @typedef {import('./schema').operations} Operations */
/** @typedef {Operations['care_management_create_test_patient']['requestBody']['content']['application/json']} CreateTestPatientRequest */
/** @typedef {Operations['care_management_create_test_patient']['responses'][201]['content']['application/json']} CreateTestPatientResponse */
/** @typedef {Operations['care_management_list_test_patients']['responses'][200]['content']['application/json']} ListTestPatientsResponse */
/** @typedef {Operations['care_management_delete_test_patient']['responses'][200]['content']['application/json']} DeleteTestPatientResponse */

/**
 * Create a synthetic care-management test patient for the current tenant.
 *
 * @param {CreateTestPatientRequest} payload
 * @param {AxiosRequestConfig} [config]
 * @returns {Promise<CreateTestPatientResponse>}
 */
export async function createCareManagementTestPatient(payload, config) {
  const { data } = await axios.post('/api/care-management/test-patient/', payload, config);
  return data;
}

/**
 * List synthetic care-management test patients for the current tenant.
 *
 * @param {AxiosRequestConfig} [config]
 * @returns {Promise<ListTestPatientsResponse>}
 */
export async function listCareManagementTestPatients(config) {
  const { data } = await axios.get('/api/care-management/test-patient/', config);
  return data;
}

/**
 * Delete a synthetic care-management test patient and its associated test data.
 *
 * @param {number} opportunityId
 * @param {AxiosRequestConfig} [config]
 * @returns {Promise<DeleteTestPatientResponse>}
 */
export async function deleteCareManagementTestPatient(opportunityId, config) {
  const { data } = await axios.delete(`/api/care-management/test-patient/${opportunityId}/`, config);
  return data;
}
